<template>
    <div>
        
    </div>
</template>
<style lang="less">

</style>
<script>

export default {
    data(){
        return {
            
        }
    },
    created (){
       
    }
}
</script>
